import React from "react";

const EmptySelectOption = () => <option />;
export default EmptySelectOption;
